import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { UserInfo } from '@tecommon/structures/structures';
import { share } from 'rxjs/operators';
import { WebServiceApplication, Ws_UserRole } from '../../../@tecommon/structures/src/selfServicePortalClasses';


@Injectable({
    providedIn: 'root',
})
export class UserInfoService {
    constructor(private http: HttpClient) { }

    public getUserInfo(): Observable<UserInfo> {
        return this.http.get<UserInfo>("/api/User/Info");
    }

    public isNetworkUser(): Observable<boolean> {
        return this.http.get<boolean>("/api/User/NetworkIDUser");
    }

    public isAppIDUser(): Observable<boolean> {
        return this.http.post<boolean>("/api/Login/IsAppIDUser", {});
    }

    //public isExternalAccess(): Observable<boolean> {
    //    return this.http.get<boolean>("/api/User/UserAccess");
    //}
    public getUserRoles(): Observable<Ws_UserRole[]> {
        return this.http.get<Ws_UserRole[]>("/api/ErgMembership/UserRoles");
    }

    public getApplication(applicationName: string): Observable<WebServiceApplication> {
        const params = new HttpParams().set('applicationName', applicationName);        
        return this.http.get<WebServiceApplication>('/api/ErgMembership/Application', { params });
       
    }


    public getMFARegistrationDetailsForUser(): Observable<boolean> {
        return this.http.get<boolean>('/api/User/IsMFARegistered');
    }
}